document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#product-filter-form');
    const productList = document.querySelector('#product-list');
    if(form && productList) {
        const url = window.ajaxurl || "/wp-admin/admin-ajax.php";
        const choicesElements = form.querySelectorAll('select');
        const filterProducts = async () => {
            const formData = new FormData(form);
            formData.append('action', 'filter_product');
            formData.append('category_id', form.dataset.currentCat || 0);

            try {
                const response = await fetch(url, { method: 'POST', body: formData });
                const data = await response.json();
                if (data?.products) {
                    productList.innerHTML = data.products;
                }
            } catch (error) {
                console.error('Erreur lors du filtrage des produits:', error);
            }
        };

        // Événement sur le changement de select
        choicesElements.forEach(select => {
            select.addEventListener('change', filterProducts);
        });
    }
});